
// Export the runtime configuration
export const config = window.__RUNTIME_CONFIG__;

// Helper function to get config values with type safety
export function getConfig(key) {
  const value = config[key];
  if (value === undefined) {
    console.warn(`Configuration key "${key}" not found`);
    return '';
  }
  return value;
}
